// src/redux/hotelSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: true,
};

const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    setHotelData(state, action) {
      // attach persisted timestamp so we can detect expiry later
      const payload = action.payload || null;
      state.data = payload ? { ...payload, __persistedAt: Date.now() } : null;
      state.loading = false;
    },
    // optional: clear hotel (eg. on logout)
    clearHotel(state) {
      state.data = null;
      state.loading = false;
    },
  },
});

export const { setHotelData, clearHotel } = hotelSlice.actions;
export default hotelSlice.reducer;
